export enum BottomPanelTab {
  TERMINAL = 'terminal',
  OUTPUT = 'output',
  PROBLEMS = 'problems',
  DEBUG_CONSOLE = 'debug_console'
}

export interface BottomPanelTabConfig {
  id: BottomPanelTab;
  label: string;
  icon: string;
  count?: number;
}
